import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { CloudDownload, ErrorOutline, Print } from "@mui/icons-material";
import { Box, Button, Card, FormLabel, Grid, Icon, MenuItem, TextField, styled } from "@mui/material";
import { Loader } from "app/components";
import { getAllProjectLocationListForBill } from "app/redux/actions/RABillActions";
import { getAllAdvanceDetailsForReport, getAllPriceAdjustmentForReport, getAllRaBillNoForReport, getContractDetailsAndRunningAccountBillDetails, getDebitCreditDetailsForRABillReport } from "app/redux/actions/ReportsAction";
import { AppConstants } from "app/utils/AppConstants";
import { ServiceUrl } from 'app/utils/Constants';
import { SnackBarProperty } from "app/utils/SnackBarProperty";
import { checkValidation, currencyFormat, formatDate, formatNumberWithCommasAndDecimals, getTwoDigitDecimal } from "app/utils/utils";
import { SimpleCard } from "components";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import moment from "moment";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";


const styles = {
  tableCell: {
    textAlign: "center"
  },
  subHeader: {
    textAlign: "center",
    fontWeight: 700
  }

}
const DecoratedTextField = styled(TextValidator)(() => ({
  width: "100%",
  marginBottom: "16px",
}));




export const RABillSummaryReport = () => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [projectDetails, setProjectDetails] = useState()
  const [isDownloading, setIsDownloading] = useState(false)
  const [isPrinting, setIsPrinting] = useState(false)
  const [subTotalAmount, setSubTotalAmount] = useState()
  const { projectLocationList } = useSelector((state) => state.raBill);
  const [raBillList, setRaBillList] = useState([])
  // const {userList}=useSelector((state)=>state.userList)
  const [descriptionTable, setDescriptionTable] = useState()
  const [priceAdjustmentTable, setPriceAdjustmentTable] = useState()
  const [priceAdjustmentSubTotalAmount, setPriceAdjustmentSubTotalAmount] = useState()
  const [advanceDetailsTable, setAdvanceDetailsTable] = useState()
  const [contractDetails, setContractDetails] = useState()
  const [totalsOfAdvanceDetails, setTotalsOfAdvanceDetails] = useState({})
  const [state, setState] = useState({
    project_location_id: '',
    ra_bill_id: ""
  })


  useEffect(() => {
    dispatch(getAllProjectLocationListForBill(showLoader, hideLoader, showToast))
  }, []);
  const showLoader = () => {
    setLoading(true)
  }
  const showToast = (msg) => {
    const key = enqueueSnackbar(msg ?? AppConstants.somethingWentWrong, { variant: 'error' });
    SnackBarProperty.error(key, closeSnackbar);
  }

  const hideLoader = () => {
    setLoading(false)
  }
  const handleChange = (event, source) => {
    setDescriptionTable()
    setAdvanceDetailsTable()
    setPriceAdjustmentTable()
    setContractDetails()
    if (event.target.name === "project_location_id") {
      setRaBillList([])
      const filteredArray = projectLocationList.filter(project => {
        return project.project_location_id === event.target.value
      });
      state.project_name = filteredArray[0].project_name
      state.project_location_id = filteredArray[0].project_location_id
      state.project_id = filteredArray[0].project_id
      setLoading(true)
      setState({ ...state, [event.target.name]: event.target.value });
      getAllRaBillNoForReport({ project_location_id: filteredArray[0].project_location_id }).then(res => {
        setLoading(false)
        if (res?.status < 300) {
          if (res?.data?.obj?.rabill_details?.length > 0) {
            setRaBillList(res?.data?.obj?.rabill_details)
          }

        } else {
          const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
          SnackBarProperty.error(key, closeSnackbar);

        }
      }).catch(error => {
        setLoading(false)
        const key = enqueueSnackbar(error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
        SnackBarProperty.error(key, closeSnackbar);

      })
    } else {
      setState({ ...state, [event.target.name]: parseInt(event.target.value) });
    }
  }


  const handleFormSubmit = async () => {
    if (state?.project_location_id === "") {
      const key = enqueueSnackbar("Please select project location", { variant: 'error' });
      SnackBarProperty.error(key, closeSnackbar);
    }
    else if (state?.ra_bill_id === "") {
      const key = enqueueSnackbar("Please select RA Bill No.", { variant: 'error' });
      SnackBarProperty.error(key, closeSnackbar);
    }
    else {
      setLoading(true)
      setDescriptionTable()
      setAdvanceDetailsTable()
      setPriceAdjustmentTable()
      setContractDetails()
      getDebitCreditDetailsForRABillReport({ project_location_id: state?.project_location_id, ra_bill_id: state?.ra_bill_id })
        .then((res) => {
          handleGetAllPriceAdjustmentForReport()
          if (res?.status < 300) {
            console.log(res?.data)
            if (res?.data?.obj) {
              if (res?.data?.obj && res?.data?.obj?.debit_credit_details && res?.data?.obj?.debit_credit_details?.length > 0) {

                setDescriptionTable(res?.data?.obj?.debit_credit_details)
                let totalCredit = 0;
                let totalDebit = 0;

                for (const item of res?.data?.obj?.debit_credit_details) {
                  totalCredit += item.credit_amount;
                  totalDebit += item.debit_amount;
                }
                const subTotal = totalCredit - totalDebit
                setSubTotalAmount(parseFloat(subTotal).toFixed(2))
                setProjectDetails({
                  company: res?.data?.obj?.agency_item,
                  tenderId: res?.data?.obj?.item?.tender_id,
                  project_name: res?.data?.obj?.item?.project_name,
                  dzongkhag_name: res?.data?.obj?.item?.dzongkhagName,
                  header: res?.data?.obj?.header_logo,
                  footer: res?.data?.obj?.footer_logo

                })
              }
            }
          }
          else {
            const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
            SnackBarProperty.error(key, closeSnackbar);

          }
        }).catch(error => {
          setLoading(false)
          const key = enqueueSnackbar(error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
          SnackBarProperty.error(key, closeSnackbar);
          handleGetAllPriceAdjustmentForReport()
        })

    }




    // function mergeByConstructionType(data) {
    //   console.log("data",data)
    //   const result = data.reduce((acc, curr) => {
    //     console.log("current",curr)
    //     const constructionType = curr.construcion_type;
    //     const totalAmount = curr.item_list.reduce((sum, item) => sum + item.amount, 0);

    //     // Create a new object with construction_type and total
    //     acc.push({ description: `Total for ${constructionType} (Nu)`, total: totalAmount });
    //     return acc;
    //   }, []);

    //   return result;
    // }


  }
  const handleGetAllPriceAdjustmentForReport = () => {
    getAllPriceAdjustmentForReport({ ra_bill_id: state?.ra_bill_id }).then(res => {
      handleGetAllAdvanceDetailsForReport()
      if (res?.status < 300) {
        console.log(res?.data)
        if (res?.data?.success) {
          if (res?.data?.obj) {
            if (res?.data?.obj && res?.data?.obj?.price_adjustment && res?.data?.obj?.price_adjustment?.length > 0) {

              setPriceAdjustmentTable(res?.data?.obj?.price_adjustment)

              const subTotal = res?.data?.obj?.price_adjustment?.reduce((accumulator, item) => {
                return accumulator + item.adjustment_amount;
              }, 0);
              setPriceAdjustmentSubTotalAmount(getTwoDigitDecimal(subTotal))
              setProjectDetails({
                company: res?.data?.obj?.item?.company,
                tenderId: res?.data?.obj?.item?.tender_id,
                project_name: res?.data?.obj?.item?.project_name,
                dzongkhag_name: res?.data?.obj?.item?.dzongkhagName,
                header: res?.data?.obj?.header_logo,
                footer: res?.data?.obj?.footer_logo

              })
            }
          }
        }
        else {
          const key = enqueueSnackbar(res?.data?.message, { variant: 'info' });
          SnackBarProperty.info(key, closeSnackbar);
        }
      }
      else {
        const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
        SnackBarProperty.error(key, closeSnackbar);

      }
    }).catch(error => {
      handleGetAllAdvanceDetailsForReport()
      const key = enqueueSnackbar(error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
      SnackBarProperty.error(key, closeSnackbar);

    })
  }

  const handleGetAllAdvanceDetailsForReport = () => {
    getAllAdvanceDetailsForReport({ project_location_id: state?.project_location_id, ra_bill_id: state?.ra_bill_id }).then(res => {
      handleGetContractDetailsAndRunningAccountBillDetails()
      if (res?.status < 300) {
        if (res?.data?.success) {
          if (res?.data?.obj?.advance_details?.length > 0) {
            setAdvanceDetailsTable(res?.data?.obj?.advance_details)
            const sumOfTotalAdvances = res?.data?.obj?.advance_details?.reduce((accumulator, item) => {
              return accumulator + item.approved_amount;
            }, 0);
            const sumOfLastRaBill = res?.data?.obj?.advance_details?.reduce((accumulator, item) => {
              return accumulator + item.recovered_amount;
            }, 0);
            const sumOfBalance = res?.data?.obj?.advance_details?.reduce((accumulator, item) => {
              return accumulator + (item.approved_amount - item.recovered_amount);
            }, 0);
            const sumOfCurrentRecovery = res?.data?.obj?.advance_details?.reduce((accumulator, item) => {
              return accumulator + item.current_recovered_amount;
            }, 0);

            setTotalsOfAdvanceDetails({
              totalAdvances: getTwoDigitDecimal(sumOfTotalAdvances),
              totalLastBill: getTwoDigitDecimal(sumOfLastRaBill),
              totalBalance: getTwoDigitDecimal(sumOfBalance),
              totalCurrentRecovery: getTwoDigitDecimal(sumOfCurrentRecovery)
            })
          }
        }
        else {
          const key = enqueueSnackbar(res?.data?.message, { variant: 'info' });
          SnackBarProperty.info(key, closeSnackbar);
        }
      }
      else {
        const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
        SnackBarProperty.error(key, closeSnackbar);

      }
    }).catch(error => {
      handleGetContractDetailsAndRunningAccountBillDetails()
      const key = enqueueSnackbar(error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
      SnackBarProperty.error(key, closeSnackbar);

    })
  }

  const handleGetContractDetailsAndRunningAccountBillDetails = () => {
    getContractDetailsAndRunningAccountBillDetails({ project_location_id: state?.project_location_id, ra_bill_id: state?.ra_bill_id }).then(res => {
      setLoading(false)
      console.log(res)
      if (res?.status < 300) {
        if (res?.data?.success) {
          if (res?.data?.obj?.item) {
            setContractDetails(res?.data?.obj?.item)
            setState({ ...state, agency_name: res?.data?.obj?.agency_name })
          }
        }
        else {
          const key = enqueueSnackbar(res?.data?.message, { variant: 'info' });
          SnackBarProperty.info(key, closeSnackbar);
        }
      }
      else {
        const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
        SnackBarProperty.error(key, closeSnackbar);

      }
    }).catch(error => {
      setLoading(false)
      const key = enqueueSnackbar(error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
      SnackBarProperty.error(key, closeSnackbar);

    })
  }

  const handleReportDownload = (isPrint) => {
    if (isPrint) {
      setIsPrinting(true)
      setIsDownloading(false)
    }
    else {
      setIsPrinting(false)
      setIsDownloading(true)
    }
    const doc = new jsPDF();

      const headerHeight = checkValidation(projectDetails?.header) ? 35 : 15
      const textX = 15;
      const textY = headerHeight
      // Add the text content below the header image
      doc.setFont('helvetica', 'bold'); // Set font to bold
      // Set font to bold
      doc.setFontSize(12); // Set font size
      doc.text("SUMMARY OF RUNNING ACCOUNT BILL", (doc.internal.pageSize.getWidth() / 2) - ((doc.getStringUnitWidth("SUMMARY OF RUNNING ACCOUNT BILL") * doc.internal.getFontSize() / doc.internal.scaleFactor) / 2), textY);

      const leftTextWidth = doc.getStringUnitWidth("Project Location:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
      const rightTextWidth = doc.getStringUnitWidth("Initial Contract Amount:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
      doc.setFontSize(8);
      doc.setFont('helvetica', 'bold');
      doc.text("Project ID: ", textX, textY + 10);
      doc.setFont('helvetica', 'normal');
      doc.text(contractDetails?.project_id ?? "", textX + leftTextWidth - 5, textY + 10);
      doc.setFont('helvetica', 'bold');
      doc.text("Bill Submission Date: ", (doc.internal.pageSize.getWidth() / 2), textY + 10);
      doc.setFont('helvetica', 'normal');
      doc.text(formatDate(contractDetails?.bill_submission_date), (doc.internal.pageSize.getWidth() / 2) + rightTextWidth - 5, textY + 10);
      doc.setFont('helvetica', 'bold');
      doc.text("Project Location: ", textX, textY + 15);
      doc.setFont('helvetica', 'normal');
      doc.text(contractDetails?.project_location ?? "", textX + leftTextWidth - 5, textY + 15);
      doc.setFont('helvetica', 'bold');
      doc.text("Initial Contract Amount: ", (doc.internal.pageSize.getWidth() / 2), textY + 15);
      doc.setFont('helvetica', 'normal');
      doc.text(`${formatNumberWithCommasAndDecimals(contractDetails?.initial_contract_amount)}`, (doc.internal.pageSize.getWidth() / 2) + rightTextWidth - 5, textY + 15);
      doc.setFont('helvetica', 'normal');
      doc.setFont('helvetica', 'bold');
      doc.text("RA Bill No: ", textX, textY + 20);
      doc.setFont('helvetica', 'normal');
      doc.text(`${contractDetails?.rabill_no ?? ""}`, textX + leftTextWidth - 5, textY + 20);
      doc.setFont('helvetica', 'bold');
      doc.text("Total Paid to Date: ", (doc.internal.pageSize.getWidth() / 2), textY + 20);
      doc.setFont('helvetica', 'normal');
      doc.text(`${formatNumberWithCommasAndDecimals(contractDetails?.total_paid_to_date)}`, (doc.internal.pageSize.getWidth() / 2) + rightTextWidth - 5, textY + 20);
      doc.setFont('helvetica', 'bold');
      doc.setFont('helvetica', 'bold');
      doc.text("RA Bill Date: ", textX, textY + 25);
      doc.setFont('helvetica', 'normal');
      doc.text(`${formatDate(contractDetails?.rabill_date)}`, textX + leftTextWidth - 5, textY + 25);
      doc.setFont('helvetica', 'bold');
      doc.text("Balance Amount: ", (doc.internal.pageSize.getWidth() / 2), textY + 25);
      doc.setFont('helvetica', 'normal');
      doc.text(`${formatNumberWithCommasAndDecimals(contractDetails?.initial_contract_amount - contractDetails?.total_paid_to_date)}`, (doc.internal.pageSize.getWidth() / 2) + rightTextWidth - 5, textY + 25);
      doc.setFont('helvetica', 'bold');

      doc.setFont('helvetica', 'bold');
      doc.text("Project Name: ", textX, textY + 30);
      doc.setFont('helvetica', 'normal');
      doc.text(contractDetails?.projectname ?? "", textX + leftTextWidth - 5, textY + 30);

      doc.setFont('helvetica', 'bold');
      doc.text("Client: ", textX, textY + 35);
      doc.setFont('helvetica', 'normal');
      doc.text(state?.agency_name ?? "", textX + leftTextWidth - 5, textY + 35);

      doc.setFont('helvetica', 'bold');
      doc.text("Contractor: ", textX, textY + 40);
      doc.setFont('helvetica', 'normal');
      doc.text(contractDetails?.company ?? "", textX + leftTextWidth - 5, textY + 40);

      const headerSectionHeight = headerHeight + 55; // Adjust the value as needed

      // Calculate the starting Y-coordinate for the table
      const tableStartY = headerSectionHeight + 5;
      doc.setFont('helvetica', 'normal');

      const body = []


      descriptionTable?.forEach((elem, index) => {
        body.push([
          { content: index === 0 ? "Total measured amount of work" : "Less Previous Running Account Total", styles: { halign: "right", fontSize: 8 } },
          { content: formatNumberWithCommasAndDecimals(parseFloat(elem?.debit_amount).toFixed(2)), styles: { halign: "right", fontSize: 8 } },
          { content: formatNumberWithCommasAndDecimals(parseFloat(elem?.credit_amount).toFixed(2)), styles: { halign: "right", fontSize: 8 } }
        ])
      })
      body.push([{ content: "Sub Total Amount", colSpan: 1, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }, { content: formatNumberWithCommasAndDecimals(subTotalAmount), colSpan: 2, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }, ""])
      body.push([{ content: "Price Adjustments", colSpan: 3, styles: { fontStyle: "bold", fontSize: 8 } }])
      priceAdjustmentTable.forEach((elem) => {
        body.push([
          { content: elem?.category, colSpan: 2, styles: { fontSize: 8 } },
          { content: formatNumberWithCommasAndDecimals(parseFloat(elem?.adjustment_amount).toFixed(2)), styles: { halign: "right", fontSize: 8 } }])
      })

      body.push([{ content: "Sub Total Amount", colSpan: 1, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }, { content: currencyFormat(priceAdjustmentSubTotalAmount), colSpan: 2, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }])

      body.push([{ content: "Less Delay Penalty", colSpan: 1, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }, { content: currencyFormat(contractDetails?.penalty_amount), styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }, ""])

      body.push([{ content: "Sub Total Amount", colSpan: 1, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }, { content: formatNumberWithCommasAndDecimals(parseFloat(parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount) - parseFloat(contractDetails?.penalty_amount)).toFixed(2)), colSpan: 2, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }])

      body.push([{ content: `Less ${parseFloat(contractDetails?.retention).toFixed(2)}% Retention`, colSpan: 1, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }, { content: formatNumberWithCommasAndDecimals((parseFloat(contractDetails?.retention / 100 * (parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount) - parseFloat(contractDetails?.penalty_amount)))).toFixed(2)), styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }, ""])

      body.push([{ content: `Less ${parseFloat(contractDetails?.tds_amount).toFixed(2)}% TDS`, colSpan: 1, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }, { content: formatNumberWithCommasAndDecimals(parseFloat((contractDetails?.tds_amount) / 100 * (parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount) - parseFloat(contractDetails?.penalty_amount))).toFixed(2)), styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }, ""])

      body.push([{ content: "Sub Total Amount", colSpan: 1, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }, { content: formatNumberWithCommasAndDecimals(parseFloat((parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount)) - (parseFloat(contractDetails?.penalty_amount)) - (parseFloat(contractDetails?.retention / 100 * (parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount) - parseFloat(contractDetails?.penalty_amount)))) - (parseFloat((contractDetails?.tds_amount) / 100 * (parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount) - parseFloat(contractDetails?.penalty_amount))))).toFixed(2)), colSpan: 2, styles: { halign: "right", fontStyle: "bold", fontSize: 8 } }])

      doc.autoTable({
         margin: { 
          top: 30,      // push below header
          bottom: 30    // leave space above footer
        },
        startY: tableStartY,
        head: [[
          { content: "DESCRIPTION", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "DEBIT (Nu)", colSpan: 1, styles: { valign: "middle", halign: "right", cellPadding: 2, fontSize: 8 } },
          { content: "CREDIT (Nu)", colSpan: 1, styles: { valign: "middle", halign: "right", cellPadding: 2, fontSize: 8 } },
          { content: "REMARKS", colSpan: 1, styles: {  valign:"middle",halign:"left",cellPadding:2,fontSize:8 } },
          // { content: "Amount (Nu)", colSpan: 1, styles: {  valign:"middle",halign:"center",cellPadding:2,fontSize:8 } }
        ]],
        body: body, // Use the transformed data here
        theme: "grid",
        styles: {
          fillColor: [255, 255, 255], // Remove background color from the table
          lineColor: [0, 0, 0], // Set border color for main table
          lineWidth: 0.1, // Set border width for main table
          textColor: [0, 0, 0], // Set text color to black
          cellPadding: 2, // Add padding to cells
        },
        columnStyles: {
          0: { cellWidth: 80 } // "ITEM DESCRIPTION" column width
          // 5: {halign:"right" }, // "RATE" column width
          // 6: {halign:"right" }, // "AMOUNT" column width
          // 3: {halign:"right" }, // "UNIT" column width
        },
      });
      const details = []
      advanceDetailsTable?.forEach((elem) => {
        details.push([
          { content: elem?.advancetype, styles: { fontSize: 8 } },
          { content: formatNumberWithCommasAndDecimals(parseFloat(elem?.approved_amount).toFixed(2)), styles: { fontSize: 8 } },
          { content: formatNumberWithCommasAndDecimals(parseFloat(elem?.recovered_amount).toFixed(2)), styles: { fontSize: 8 } },
          { content: formatNumberWithCommasAndDecimals(parseFloat(elem?.approved_amount - elem?.recovered_amount).toFixed(2)), styles: { fontSize: 8 } },
          { content: formatNumberWithCommasAndDecimals(parseFloat(elem?.current_recovered_amount).toFixed(2)), styles: { fontSize: 8 } }
        ])
      })
      details.push([{ content: "Sub Total", styles: { fontStyle: "bold", fontSize: 8 } }, { content: formatNumberWithCommasAndDecimals(totalsOfAdvanceDetails?.totalAdvances), styles: { fontStyle: "bold", halign: "right", fontSize: 8 } }, { content: formatNumberWithCommasAndDecimals(totalsOfAdvanceDetails?.totalLastBill), styles: { fontStyle: "bold", halign: "right", fontSize: 8 } }, { content: formatNumberWithCommasAndDecimals(totalsOfAdvanceDetails?.totalBalance), styles: { fontStyle: "bold", halign: "right", fontSize: 8 } }, { content: formatNumberWithCommasAndDecimals(totalsOfAdvanceDetails?.totalCurrentRecovery), styles: { fontStyle: "bold", halign: "right", fontSize: 8 } }])
      doc.autoTable({
         margin: { 
          top: 30,      // push below header
          bottom: 30    // leave space above footer
        },
        startY: doc.autoTable.previous.finalY + 6,
        head: [[
          { content: "Reclaim of Advances", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "Total Advances", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "Advance Recovered till last RA Bill", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "Balance", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "Current Recovery", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          // { content: "Category", colSpan: 1, styles: {  valign:"middle",halign:"center",cellPadding:2,fontSize:8 } },
          // { content: "Amount (Nu)", colSpan: 1, styles: {  valign:"middle",halign:"center",cellPadding:2,fontSize:8 } }
        ]],
        body: details, // Use the transformed data here
        theme: "grid",
        styles: {
          fillColor: [255, 255, 255], // Remove background color from the table
          lineColor: [0, 0, 0], // Set border color for main table
          lineWidth: 0.1, // Set border width for main table
          textColor: [0, 0, 0], // Set text color to black
          cellPadding: 2, // Add padding to cells
        },
        columnStyles: {
          0: { cellWidth: 50 }, // "ITEM DESCRIPTION" column width
          1: { halign: "right" }, // "RATE" column width
          2: { halign: "right" }, // "AMOUNT" column width
          3: { halign: "right" },
          4: { halign: "right" }, // "UNIT" column width
        },
      });
      doc.setFont('helvetica', 'bold');
      doc.text('Net Payment to Contractor (Nu.):', textX, doc.autoTable.previous.finalY + 10);
      const textWidth = doc.getStringUnitWidth("Net Payment to Contractor (Nu.):") * doc.internal.getFontSize() / doc.internal.scaleFactor;
      doc.setFont('helvetica', 'bold');
      doc.text(`${formatNumberWithCommasAndDecimals(parseFloat((parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount)) - (parseFloat(contractDetails?.penalty_amount)) - (parseFloat(contractDetails?.retention / 100 * (parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount) - parseFloat(contractDetails?.penalty_amount)))) - (parseFloat((contractDetails?.tds_amount) / 100 * (parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount) - parseFloat(contractDetails?.penalty_amount)))) - getTwoDigitDecimal(totalsOfAdvanceDetails?.totalCurrentRecovery)).toFixed(2))}`, textX + textWidth + 5, doc.autoTable.previous.finalY + 10);

      const totalNumPages = doc.internal.getNumberOfPages();

      // Loop through each page to add the footer with page numbers
      for (let i = 1; i <= totalNumPages; i++) {
  
        const pdfWidth = doc.internal.pageSize.getWidth() - 30;
  
        // Header
        const headerHeight = 20;
        const headerX = 15;
        const headerY = 0; // at the very top
        if (checkValidation(projectDetails?.header)) {
          doc.addImage(
            `${ServiceUrl?.showImageUrl}${projectDetails?.header}`,
            headerX,
            headerY,
            pdfWidth,
            headerHeight
          );
        }
  
        //Footer
        const footerX = 15; // Starting X position for the footer
        const footerY = doc.internal.pageSize.getHeight() - 20; // 10 units from the bottom
        const footerHeight = 20;
        doc.setPage(i);
        if (checkValidation(projectDetails?.footer)) {
          doc.addImage(`${ServiceUrl?.showImageUrl}${projectDetails?.footer}`, footerX, footerY, pdfWidth, footerHeight)
        }
      }

      const scaleFactor = 1.0; // Adjust this value as needed
      const pdfBlob = doc.output('blob', { scale: scaleFactor });

      // Create a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // Open a new window with the PDF URL

      if (isPrint) {
        const newWindow = window.open(pdfUrl, '_blank');

        // After the new window is opened, you can close the URL object
        URL.revokeObjectURL(pdfUrl);
        if (newWindow) {
          newWindow.onload = () => {
            setIsPrinting(false)
            setIsDownloading(false)
            // Wait for the window to load and then trigger the print dialog
            newWindow.print();
          };
        }
      }

      setIsPrinting(false)
      setIsDownloading(false)

      isPrint === false && doc.save("Ra_Bill_Summary_Report.pdf");
  };



  return (
    <>
      <div style={{ height: 'auto', width: "100%", padding: '30px', display: "flex", flexDirection: "column", gap: "20px" }}>

        <Grid container>

          <Grid item xs={12}>
            <Button
              size="small"
              sx={{ width: "100px" }}
              variant="contained"
              color="error"
              onClick={() => { window.history.back() }}
            >
              <Icon color="primary" fontSize="small">
                skip_previous
              </Icon>
              Back
            </Button>
          </Grid>
        </Grid>
        <SimpleCard>
          <ValidatorForm onSubmit={handleFormSubmit}>
            <Grid container spacing={3} style={{ marginTop: '-45px', marginBottom: '15px' }} >
              <Grid item xs={12}><b className="font20 extraBold" style={{ color: "#ebad4e" }}>Summary of RA Bill</b></Grid>
            </Grid>
            <Grid container spacing={3} >

              <Grid item sm={4} xs={12}>
                <TextField
                  select
                  size="small"
                  fullWidth
                  sx={{ mb: 3 }}
                  label="Project ID"
                  id="project_location_id"
                  variant="outlined"
                  name="project_location_id"
                  value={state?.project_location_id}
                  onChange={handleChange}
                  validators={["required"]}
                  errorMessages={["Project ID is required"]}
                >
                  {projectLocationList?.map((item) => (
                    <MenuItem value={item?.project_location_id} key={item?.project_id}>
                      {item?.project_id}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item sm={4} xs={12}>
                <TextField
                  select
                  size="small"
                  fullWidth
                  sx={{ mb: 3 }}
                  label="RA Bill No."
                  id="rabill_id"
                  variant="outlined"
                  name="ra_bill_id"
                  value={state?.ra_bill_id}
                  onChange={handleChange}
                  validators={["required"]}
                  errorMessages={["RA Bill No. is required"]}
                >
                  {raBillList?.map((item) => (
                    <MenuItem value={parseInt(item?.runningaccountbill_id)} key={item?.runningaccountbill_id}>
                      {item?.rabill_no}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item sm={4} xs={12}>


                <Button size="medium" color="success" variant="contained" type="submit" style={{ marginLeft: 4 }} >View</Button>

              </Grid>

            </Grid>

          </ValidatorForm>
        </SimpleCard>
        {
          descriptionTable && priceAdjustmentTable && advanceDetailsTable && projectDetails && descriptionTable?.length > 0 && priceAdjustmentTable?.length > 0 && advanceDetailsTable?.length > 0 && Object.keys(projectDetails)?.length > 0 &&
          <Grid container>
            <Grid xs={12} md={6}>
              {/* {checkValidation(projectDetails?.header) === false && <FormLabel sx={{ color: "#ff9800" }} color="warning">! Please upload header and footer for download/print</FormLabel>} */}
            </Grid>
            <Grid item xs={12} md={6}>
              <Box component="span" display="flex" justifyContent="flex-end">
                <Button
                  size="small"
                  sx={{ width: "130px", marginLeft: 4 }}
                  variant="contained"
                  color="warning"
                  // disabled={projectDetails?.header ? false : true}
                  startIcon={<CloudDownload />}
                  onClick={() => { handleReportDownload(false) }}
                >
                  Download
                </Button>
                <Button
                  size="small"
                  sx={{ width: "100px", marginLeft: 2 }}
                  variant="contained"
                  color="primary"
                  // disabled={projectDetails?.header ? false : true}
                  startIcon={<Print />}
                  onClick={() => { handleReportDownload(true) }}
                >
                  Print
                </Button>
              </Box>
            </Grid>

          </Grid>}

        {/* table */}
        {
          descriptionTable && priceAdjustmentTable && advanceDetailsTable && projectDetails && descriptionTable?.length > 0 && priceAdjustmentTable?.length > 0 && advanceDetailsTable?.length > 0 && Object.keys(projectDetails)?.length > 0 &&
          <Card sx={{ padding: 3 }}>

            <div style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px" }}>
              <div id="header" style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px", paddingLeft: "100px", paddingRight: "100px" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", gap: "20px", alignItems: "center" }}>
              {checkValidation(projectDetails?.header) && 
                  <img id="headerLogo" src={`${ServiceUrl?.showImageUrl}${projectDetails?.header}`} style={{ height: "150px", width: "auto" }} alt="img" />
                  }

                </div>

                <Grid container>
                  <Grid item xs={12} sx={{ marginTop: 2, textAlign: "center" }}>
                    <FormLabel sx={{ fontSize: 20 }}><b>SUMMARY OF RUNNING ACCOUNT BILL</b></FormLabel>
                  </Grid>
                  <Grid item xs={12} sx={{ marginTop: 2, display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "flex-start", justifyContent: "space-between", gap: 2 }}>
                    <FormLabel sx={{ fontSize: 18, width: "50%" }}><b>Project ID: </b>{contractDetails?.project_id}</FormLabel>
                    <FormLabel sx={{ fontSize: 18, width: "50%" }}><b>Bill Submission Date: </b>{formatDate(contractDetails?.bill_submission_date)}</FormLabel>
                  </Grid>
                  <Grid item xs={12} sx={{ marginTop: 2, display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "flex-start", justifyContent: "space-between", gap: 2 }}>
                    <FormLabel sx={{ fontSize: 18, width: "50%" }}><b>Project Location: </b>{contractDetails?.project_location}</FormLabel>
                    <FormLabel sx={{ fontSize: 18, width: "50%" }}><b>Initial Contract Amount: </b>{formatNumberWithCommasAndDecimals(contractDetails?.initial_contract_amount)}</FormLabel>
                  </Grid>
                  <Grid item xs={12} sx={{ marginTop: 2, display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "flex-start", justifyContent: "space-between", gap: 2 }}>
                    <FormLabel sx={{ fontSize: 18, width: "50%" }}><b>RA Bill No.: </b>{contractDetails?.rabill_no}</FormLabel>
                    <FormLabel sx={{ fontSize: 18, width: "50%" }}><b>Total Paid to Date: </b>{formatNumberWithCommasAndDecimals(contractDetails?.total_paid_to_date)}</FormLabel>
                  </Grid>
                  <Grid item xs={12} sx={{ marginTop: 2, display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "flex-start", justifyContent: "space-between", gap: 2 }}>
                    <FormLabel sx={{ fontSize: 18, width: "50%" }}><b>Bill Date: </b>{formatDate(contractDetails?.rabill_date)}</FormLabel>
                    <FormLabel sx={{ fontSize: 18, width: "50%" }}><b>Balance Amount: </b>{formatNumberWithCommasAndDecimals(contractDetails?.initial_contract_amount - contractDetails?.total_paid_to_date)}</FormLabel>
                  </Grid>
                  <Grid item xs={12} sx={{ marginTop: 2, display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "flex-start", justifyContent: "space-between", gap: 2 }}>
                    <FormLabel sx={{ fontSize: 18 }}><b>Project Name: </b>{contractDetails?.projectname}</FormLabel>
                  </Grid>
                  <Grid item xs={12} sx={{ marginTop: 2, display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "flex-start", justifyContent: "space-between", gap: 2 }}>
                    <FormLabel sx={{ fontSize: 18 }}><b>Client: </b>{state?.agency_name}</FormLabel>
                  </Grid>
                  <Grid item xs={12} sx={{ marginTop: 2, display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "flex-start", justifyContent: "space-between", gap: 2 }}>
                    <FormLabel sx={{ fontSize: 18 }}><b>Contractor: </b>{contractDetails?.company}</FormLabel>
                  </Grid>

                </Grid>
              </div>

              <div id="tableData">
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead style={{ backgroundColor: '#87CEEB' }}>
                      <TableRow>
                        <TableCell width='35%'>DESCRIPTION</TableCell>
                        <TableCell width='15%' align="right">DEBIT (Nu)</TableCell>
                        <TableCell width='15%' align="right">CREDIT (Nu)</TableCell>
                        <TableCell width='25%' align="left">REMARKS</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {descriptionTable?.length > 0 &&
                        <>
                          {descriptionTable?.length > 0 && descriptionTable?.map((elem, index) => {
                            return (
                              <TableRow>
                                <TableCell >{index === 0 ? "Total measured amount of work" : "Less Previous Running Account Total"}</TableCell>
                                <TableCell align="right">{formatNumberWithCommasAndDecimals(parseFloat(elem?.debit_amount).toFixed(2))}</TableCell>
                                <TableCell align="right">{formatNumberWithCommasAndDecimals(parseFloat(elem?.credit_amount).toFixed(2))}</TableCell>
                                <TableCell ></TableCell>
                              </TableRow>
                            )
                          }
                          )
                          }
                          <TableRow>
                            <TableCell colSpan={1} sx={{ fontWeight: 600 }} align="center"><b>Sub-Total</b></TableCell>
                            <TableCell colSpan={1} sx={{ fontWeight: 600 }} align="right" ></TableCell>
                            <TableCell align="right" sx={{ fontWeight: 600 }}>
                              <b>{formatNumberWithCommasAndDecimals(parseFloat(subTotalAmount).toFixed(2))}</b>
                            </TableCell>

                          </TableRow>
                        </>}
                      {priceAdjustmentTable?.length > 0 && <>
                        <TableRow>
                          <TableCell colSpan={3} sx={{ fontWeight: 600 }} ><b>Price Adjustment</b></TableCell>
                        </TableRow>
                        {priceAdjustmentTable?.length > 0 && priceAdjustmentTable?.map((elem, index) => {
                          return (
                            <TableRow>
                              <TableCell colSpan={1}>{elem?.category}</TableCell>
                              <TableCell></TableCell>
                              {/* <TableCell align="right">{parseFloat(elem?.debit_amount).toFixed(2)}</TableCell> */}
                              <TableCell align="right">{formatNumberWithCommasAndDecimals(parseFloat(elem?.adjustment_amount).toFixed(2))}</TableCell>

                            </TableRow>
                          )
                        }
                        )
                        }
                        <TableRow>
                          <TableCell colSpan={1} sx={{ fontWeight: 600 }} align="center"><b>Sub-Total</b></TableCell>
                          <TableCell colSpan={1} sx={{ fontWeight: 600 }} align="right" ></TableCell>
                          <TableCell align="right" sx={{ fontWeight: 600 }}>
                            <b>{formatNumberWithCommasAndDecimals(parseFloat(priceAdjustmentSubTotalAmount).toFixed(2))}</b>
                          </TableCell>

                        </TableRow>
                      </>
                      }
                      <TableRow>
                        <TableCell colSpan={1} sx={{ fontWeight: 600 }} align="left" ><b>Less Delay Penalty</b></TableCell>
                        <TableCell colSpan={1} sx={{ fontWeight: 600 }} align="right" ><b>{formatNumberWithCommasAndDecimals(parseFloat(contractDetails?.penalty_amount).toFixed(2))}</b></TableCell>
                        <TableCell colSpan={1} sx={{ fontWeight: 600 }} align="right" ></TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={1} sx={{ fontWeight: 600 }} align="center" ><b>Sub-Total</b></TableCell>
                        <TableCell colSpan={2} sx={{ fontWeight: 600 }} align="right" ><b>{formatNumberWithCommasAndDecimals(parseFloat(parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount) - parseFloat(contractDetails?.penalty_amount)).toFixed(2))}</b></TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={1} sx={{ fontWeight: 600 }} align="left" ><b>Less {parseFloat(contractDetails?.retention).toFixed(2)}% Retention</b></TableCell>
                        <TableCell colSpan={1} sx={{ fontWeight: 600 }} align="right" ><b>{formatNumberWithCommasAndDecimals((parseFloat(contractDetails?.retention / 100 * (parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount) - parseFloat(contractDetails?.penalty_amount)))).toFixed(2))}</b></TableCell>
                        <TableCell colSpan={1} sx={{ fontWeight: 600 }} align="right" ></TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell colSpan={1} sx={{ fontWeight: 600 }} align="left" ><b>Less {parseFloat(contractDetails?.tds_amount).toFixed(2)}% TDS</b></TableCell>
                        <TableCell colSpan={1} sx={{ fontWeight: 600 }} align="right" ><b>{formatNumberWithCommasAndDecimals(parseFloat((contractDetails?.tds_amount) / 100 * (parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount) - parseFloat(contractDetails?.penalty_amount))).toFixed(2))}</b></TableCell>
                        <TableCell colSpan={1} sx={{ fontWeight: 600 }} align="right" ></TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={1} sx={{ fontWeight: 600 }} align="center" ><b>Sub-Total</b></TableCell>
                        <TableCell colSpan={2} sx={{ fontWeight: 600 }} align="right" ><b>{formatNumberWithCommasAndDecimals(parseFloat((parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount)) - (parseFloat(contractDetails?.penalty_amount)) - (parseFloat(contractDetails?.retention / 100 * (parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount) - parseFloat(contractDetails?.penalty_amount)))) - (parseFloat((contractDetails?.tds_amount) / 100 * (parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount) - parseFloat(contractDetails?.penalty_amount))))).toFixed(2))}</b></TableCell>
                      </TableRow>

                    </TableBody>
                  </Table>
                </TableContainer>
                {advanceDetailsTable !== null && advanceDetailsTable !== undefined && advanceDetailsTable?.length > 0 &&
                  <TableContainer component={Paper} style={{ marginTop: "40px" }}>
                    <Table>
                      <TableHead style={{ backgroundColor: '#87CEEB' }}>
                        <TableRow>
                          <TableCell>Reclaim of Advances</TableCell>
                          <TableCell align="right">Total Advances</TableCell>
                          <TableCell align="right">Advance Recovered till last RA bill</TableCell>
                          <TableCell align="right">Balance</TableCell>
                          <TableCell align="right">Current Recovery</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {advanceDetailsTable?.length > 0 &&
                          <>
                            {advanceDetailsTable?.length > 0 && advanceDetailsTable?.map((elem, index) => {
                              return (
                                <TableRow>
                                  <TableCell >{elem?.advancetype}</TableCell>
                                  <TableCell align="right">{formatNumberWithCommasAndDecimals(parseFloat(elem?.approved_amount).toFixed(2))}</TableCell>
                                  <TableCell align="right">{formatNumberWithCommasAndDecimals(parseFloat(elem?.recovered_amount).toFixed(2))}</TableCell>
                                  <TableCell align="right">{formatNumberWithCommasAndDecimals(parseFloat(elem?.approved_amount - elem?.recovered_amount).toFixed(2))}</TableCell>
                                  <TableCell align="right">{formatNumberWithCommasAndDecimals(parseFloat(elem?.current_recovered_amount).toFixed(2))}</TableCell>

                                </TableRow>
                              )
                            }
                            )
                            }
                            <TableRow>
                              <TableCell ><b>Total</b></TableCell>
                              <TableCell align="right"><b>{formatNumberWithCommasAndDecimals(totalsOfAdvanceDetails?.totalAdvances)}</b></TableCell>
                              <TableCell align="right"><b>{formatNumberWithCommasAndDecimals(totalsOfAdvanceDetails?.totalLastBill)}</b></TableCell>
                              <TableCell align="right"><b>{formatNumberWithCommasAndDecimals(totalsOfAdvanceDetails?.totalBalance)}</b></TableCell>
                              <TableCell align="right"><b>{formatNumberWithCommasAndDecimals(totalsOfAdvanceDetails?.totalCurrentRecovery)}</b></TableCell>
                            </TableRow>
                          </>}


                      </TableBody>
                    </Table>

                  </TableContainer>
                }
                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Net Payment to Contractor (Nu):   </b>{"   " + formatNumberWithCommasAndDecimals(parseFloat((parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount)) - (parseFloat(contractDetails?.penalty_amount)) - (parseFloat(contractDetails?.retention / 100 * (parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount) - parseFloat(contractDetails?.penalty_amount)))) - (parseFloat((contractDetails?.tds_amount) / 100 * (parseFloat(subTotalAmount) + parseFloat(priceAdjustmentSubTotalAmount) - parseFloat(contractDetails?.penalty_amount)))) - getTwoDigitDecimal(totalsOfAdvanceDetails?.totalCurrentRecovery)).toFixed(2))}</FormLabel>
                </Grid>
              </div>
            </div>
          </Card>}
      </div>

      {loading && (
        <Loader
          show={loading}
        />
      )}
      
      {(isPrinting || isDownloading) && (
        <Loader
          show={isPrinting ? isPrinting : isDownloading}
          text="Processing...Please wait."
        />
      )}

    </>
  )
}